import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return {
          hours: 23,
          minutes: 59,
          seconds: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <section className="bg-brand-dark py-5 px-5" data-id="element-83">
      <div className="max-w-xl mx-auto text-center" data-id="element-84">
        <p className="text-sm text-gray-400 mb-4 font-medium" data-id="element-85">
          ⏰ El precio de lanzamiento termina en:
        </p>
        <div className="flex items-center justify-center gap-2 mb-3" data-id="element-86">
          <TimeBlock value={formatTime(timeLeft.hours)} label="HRS" data-id="element-87" />
          <span className="text-red-500 text-2xl font-bold" data-id="element-88">:</span>
          <TimeBlock value={formatTime(timeLeft.minutes)} label="MIN" data-id="element-89" />
          <span className="text-red-500 text-2xl font-bold" data-id="element-90">:</span>
          <TimeBlock value={formatTime(timeLeft.seconds)} label="SEG" data-id="element-91" />
        </div>
        <p className="text-xs text-red-400 font-semibold" data-id="element-92">
          Después sube de precio y no vuelve a bajar.
        </p>
      </div>
    </section>;
}
function TimeBlock({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="bg-gray-900 border border-red-600 rounded-lg px-4 py-2 min-w-[60px] text-center" data-id="element-93">
      <div className="text-2xl font-black text-red-500" data-id="element-94">{value}</div>
      <div className="text-[9px] text-red-400 uppercase tracking-wider" data-id="element-95">
        {label}
      </div>
    </div>;
}